import React from 'react';

import Loading from 'src/components/core/Loading';
import {Layout} from 'src/return/Layout';
import {ScreenManager} from 'src/return/ScreenManager';
import {getStore} from 'src/return/state/store';
import {useReturnDetailsCollectionContext} from 'src/return/state/useReturnDetailsCollectionContext';
import {useStateInitialize} from 'src/return/state/useStateInitialize';

const App = (): React.ReactElement => {
  const sessionContext = useReturnDetailsCollectionContext();
  const store = getStore();
  useStateInitialize(sessionContext);

  const isSessionLoaded = store.useSelector((state) => state.id.length > 0);

  if (!isSessionLoaded) {
    return <Loading />;
  }

  return (
    <Layout>
      <ScreenManager />
    </Layout>
  );
};

export default App;
